import styled from 'styled-components';

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
};

export const Icon = styled.div`
  align-self: start;
  padding-top: 0.2rem;
`;

export const Profile = styled.div`
  /* margin-left: 30px; */
`;

export const ProfileList = styled.ul`
  font-size: 0.9rem;
  display: grid;
  grid-template-rows: auto;
  justify-content: start;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const Description = styled.li`
  display: inline-grid;
  grid-template-columns: auto auto;
  grid-gap: 0.5rem;
  justify-content: start;
`;

export const Text = styled.div`
  align-self: center;
  font-size: 0.9rem;
`;
